import React, { useEffect, useMemo, useState } from 'react';
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, Tooltip, ResponsiveContainer, LabelList, Cell } from 'recharts';
import { useAuth } from '../../context/AuthContext';
import { fetchYardsApi } from '../../services/api';
import { serviceReportCompletadas } from '../../services/Reportes/ServicesReports';
import { Cargando } from '../../components/Cargando';

export default function RondasPlanificasVsCompletadas() {
  const { token } = useAuth();

  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [yardId, setYardId] = useState('');
  const [yards, setYards] = useState([]);

  const [loadingYards, setLoadingYards] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [errorMsg, setErrorMsg] = useState('');

  const [report, setReport] = useState(null);
  const colors = ['#80808080', '#007bff', '#dc3545', '#FFC107'];
  useEffect(() => {
    (async () => {
      setLoadingYards(true);
      setErrorMsg('');
      try {
        const list = await fetchYardsApi({ token });
        setYards((list || []).sort((a, b) => a.nombre.localeCompare(b.nombre)));
      } catch (err) {
        console.error(err);
        setErrorMsg('No se pudieron cargar los patios.');
      } finally {
        setLoadingYards(false);
      }
    })();
  }, [token]);

  const chartData = useMemo(() => {
    if (!report) return [];
    const planned = Number(report.planned || 0);
    const completed = Number(report.completed || 0);
    const emergencyCancelled = Number(report.emergencyCancelled || 0);
    const supervisorCancelled = Number(report.supervisorCancelled || 0);
    return [
      { name: 'Planificadas', valor: planned },
      { name: 'Completadas', valor: completed },
      { name: 'Emergencias', valor: emergencyCancelled },
      { name: 'Canceladas', valor: supervisorCancelled },
    ];
  }, [report]);

  const onSubmit = async (e) => {
    e.preventDefault();
    setErrorMsg('');
    setReport(null);

    if (!startDate || !endDate || !yardId) {
      setErrorMsg('Seleccione patio y rango de fechas.');
      return;
    }

    setSubmitting(true);
    try {
      const res = await serviceReportCompletadas({ startDate, endDate, yardId, token });
      console.log(res);
      setReport(res || null);
    } catch (err) {
      console.error(err);
      setErrorMsg('No se pudo obtener el reporte.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="container-fluid">
      <h4 className="mb-3">Rondas Planificadas vs Completadas</h4>

      <div className="card">
        <div className="card-body">
          <form onSubmit={onSubmit}>
            <div className="row g-3 align-items-end">
              <div className="col-12 col-md-4">
                <label className="form-label">Patio</label>
                <select
                  className="form-select"
                  value={yardId}
                  onChange={(e) => setYardId(e.target.value)}
                  disabled={loadingYards}
                >
                  <option value="">-- Selecciona --</option>
                  {yards.map((y) => (
                    <option key={y.id} value={y.id}>{y.nombre}</option>
                  ))}
                </select>
                {loadingYards && <div className="form-text">Cargando patios...</div>}
              </div>

              <div className="col-12 col-md-4">
                <label className="form-label">Fecha inicio</label>
                <input type="date" className="form-control" value={startDate} onChange={(e) => setStartDate(e.target.value)} />
              </div>

              <div className="col-12 col-md-4">
                <label className="form-label">Fecha fin</label>
                <input type="date" className="form-control" value={endDate} onChange={(e) => setEndDate(e.target.value)} />
              </div>

              <div className="col-12">
                <button className="btn btn-primary" type="submit" disabled={submitting || loadingYards}>
                  {submitting ? 'Consultando...' : 'Consultar'}
                </button>
              </div>
            </div>
          </form>

          {errorMsg && <div className="alert alert-danger mt-3">{errorMsg}</div>}

          <div className="mt-3">
            {submitting && <Cargando />}

            {!submitting && report && (
              <>
                <div className="row g-3 justify-content-center">
                  <div className="col-12 col-lg-12">
                    <div className="border rounded p-3" style={{ height: 500 }}>
                      <ResponsiveContainer width="100%" height="100%">
                        <BarChart data={chartData} margin={{ top: 20, right: 20, bottom: 20, left: 0 }}>
                          <CartesianGrid strokeDasharray="3 3" />
                          <XAxis dataKey="name" />
                          <YAxis allowDecimals={false} />
                          <Tooltip />
                          <Bar dataKey="valor" fill="#000000" barSize={100-200}>
                            {chartData.map((entry, index) => (
                              <Cell key={index} fill={colors[index]} />
                            ))}
                            <LabelList dataKey="valor" position="top"  />
                          </Bar>
                        </BarChart>
                      </ResponsiveContainer>
                    </div>
                  </div>
                </div>

                {/* <div className="row g-3 justify-content-center mt-2">
                  <div className="col-12 col-lg-8">
                    <div className="border rounded p-3">
                      <div className="fw-semibold mb-2">Resumen</div>
                      <ul className="mb-0">
                        <li>Planificadas: {Number(report.planned || 0)}</li>
                        <li>Completadas: {Number(report.completed || 0)}</li>
                        <li>Pendientes: {Number(report.pending || 0)}</li>
                        <li>En progreso: {Number(report.inProgress || 0)}</li>
                        <li>Canceladas por emergencia: {Number(report.emergencyCancelled || 0)}</li>
                        <li>Canceladas por supervisor: {Number(report.supervisorCancelled || 0)}</li>
                        <li>% Completadas: {Number(report.pctCompleted || 0)}%</li>
                      </ul>
                    </div>
                  </div>
                </div> */}
              </>
            )}

            {!submitting && !report && !errorMsg && (
              <div className="text-muted">Completa los filtros y consulta para ver el gráfico.</div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
